import LoggerServer from '../../server/logger';
import { addLoading, removeLoading } from './loading';

export const setLogs = (logs) => ({
  type: 'SET_DEVELOP_LOGGER_GRID',
  payload: logs,
});

export const getAllLogs = (tableParams = {}) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const logs = await LoggerServer.getAllLogs(tableParams);
    dispatch(setLogs(logs ? logs.rows : []));
    dispatch(removeLoading());
    return logs || 0;
  } catch (e) {
    dispatch(removeLoading());
    return 0;
  }
};
